export default __webpack_public_path__ + "static/media/HR001.a9d61af5.png";